import WorkArea from './workarea.vue'
export default WorkArea



// WEBPACK FOOTER //
// ./src/lib/components/workarea/index.js